<template>
  <div id="closest-stop">

    <ClosestIsLoading></ClosestIsLoading>

    <div
      v-for="(dir, index) in Object.keys(stops)"
      :key="index"
      class="closest-stop-by-route"
    >
      <router-link
        :to="{
                name: 'routeinfo',
                params: {
                    id: stops[dir].routeid
                }
            }"
        class="full-width-link"
      >
        <div class="route-info">

          <div class="route-upper">
            <div class="routec">{{ stops[dir].routec }}</div>
            <div class="stopc">{{ stops[dir].stopc }}</div>
          </div>

          <div class="route-lower">
            <div class="destin">{{
                stops[dir].routedir === 2 ? stops[dir].destinc :
                  stops[dir].startc
              }}
            </div>
          </div>

        </div>
        <div class="route-eta">
          <GetEta
            :stop-details="stops[dir]"></GetEta>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import GetEta from "../Eta/GetEta";
import ClosestIsLoading from "./ClosestIsLoading";

export default {
  name: "ClosestStopByRoute",
  components: {ClosestIsLoading, GetEta},
  computed: {
    ...mapState('nearbyRoutes', ['byRoute', 'locationSet', 'loading']),
    stops() {
      const stopList = this.byRoute;

      console.log('settings stops');

      return stopList.reduce((acc, cur) => {
        if (acc.startc == null || acc.destinc == null) {
          if (cur.routedir === 2) {
            if (acc.startc == null) {
              console.log('setting startc');

              acc.startc = cur;
            }
          }

          if (cur.routedir === 1) {
            if (acc.destinc == null) {
              console.log('setting destinc');

              acc.destinc = cur;
            }
          }
        }

        console.log(acc);

        return acc;
      }, {});

    },
  },
  methods: {
    ...mapActions('nearbyRoutes', ['getNearbyStopByRoute']),

  },
  watch: {
    '$route.params.id'(id) {
      this.getNearbyStopByRoute({
        routeid: id,
      });
    }
  },
  mounted() {
    this.getNearbyStopByRoute({
      routeid: this.$route.params.id,
    });
  }
}
</script>

<style scoped>
.closest-stop-by-route {
  padding: 8px;
  border-bottom: 1px solid #CCCCCC;
}

.full-width-link {
  width: 100%;
}

.favourite-route {
  display: block;
  width: 100%;
}

.route-upper {
  font-size: 16px;
  display: flex;
  margin-bottom: 2px;
}

.routec, .stopc {
  display: inline-block;
}

.routec {
  margin-right: 8px;
  font-weight: bold;
}

.route-lower {
  font-size: 12px;
  color: #4D4D4D
}

.destin::before {
  content: '往';
  margin-right: 4px;
}

.route-info, .route-eta {
  display: inline-block;
}

.route-info {
  float: left;
  width: 55%
}

.route-eta {
  float: right;
  width: 40%
}
</style>
